const getTranches = (state) => {
  return state.tranches
}

const getStatuses = (state) => {
  return state.statuses
}

const getSearchTranches = (state) => {
  return state.searchTranches
}

const getTranchesPending = (state) => {
  return state.pending
}

const getPagination = (state) => {
  return state.tranchesPagination
}

const getSearchPagination = (state) => {
  return state.searchPagination
}

const isSearchDataExist = (state) => {
  return state.searchDataExist
}

export default {
  getTranches,
  getStatuses,
  getTranchesPending,
  getSearchTranches,
  getSearchPagination,
  getPagination,
  isSearchDataExist
}



// WEBPACK FOOTER //
// ./src/store/modules/tranches/getters.js